var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hatchEnrichmentEnabled)?_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.openModal}},[_c('b-img',{attrs:{"center":"","src":require('@/assets/img/BitmapHetch.png'),"width":"24","height":"24","alt":"Hatch Enrichment"}})],1):_vm._e(),_c('HatchEnrichmentModal',{ref:"hatchEnrichmentModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }